var map = {
	"./de/return.png": "trLu",
	"./en/return.png": "4PGt",
	"./es/return.png": "Zu2a",
	"./fr/return.png": "FHI6",
	"./ja/return.png": "xrTt",
	"./ko/return.png": "fpVd",
	"./pt/return.png": "gZUe",
	"./ru/return.png": "8M5D",
	"./tc/return.png": "P3IN",
	"./th/return.png": "YE2C"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GFC1";